export var SortDirectionNumber;
(function (SortDirectionNumber) {
    SortDirectionNumber[SortDirectionNumber["asc"] = 1] = "asc";
    SortDirectionNumber[SortDirectionNumber["desc"] = -1] = "desc";
    SortDirectionNumber[SortDirectionNumber["neutral"] = 0] = "neutral";
})(SortDirectionNumber || (SortDirectionNumber = {}));
//# sourceMappingURL=sortDirectionNumber.enum.js.map